function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.3591 5.41663H16.641C13.6418 5.41663 11.188 7.85413 11.188 10.8333V54.1666C11.188 57.1458 13.6418 59.5833 16.641 59.5833H49.3591C52.3583 59.5833 54.8121 57.1458 54.8121 54.1666V10.8333C54.8121 7.85413 52.3583 5.41663 49.3591 5.41663ZM24.8205 10.8333H30.2736V24.375L27.5471 22.3437L24.8205 24.375V10.8333ZM16.641 54.1666H49.3591V10.8333H35.7266V35.2083L27.5471 29.1145L19.3675 35.2083V10.8333H16.641V54.1666Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 33.0001,
  y1: 5.41663,
  x2: 33.0001,
  y2: 59.5833,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/CourseIcon.143169f0.svg";
export { SvgComponent as ReactComponent };